import { Component, OnInit, ViewEncapsulation, HostListener } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { MenuItem } from 'primeng/api';
import { Router } from '@angular/router';
import { validateBasis } from '@angular/flex-layout';
import { User, LanguageService, AccountService } from '../../../lib/src/public-api';
import { SurveyConfigService } from './services/survey-config.service';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class AppComponent implements OnInit {
  title = 'Surveys';
  topSidebarVisible = true;
  leftSidebarVisible = false;
  version = 'Foy - version 2.0.0.0';
  headerText = 'Surveys';
  screenWidth;
  items: MenuItem[] | undefined;
  isUserLoggedIn: boolean;
  user: User;

  constructor(public translate: TranslateService,
    private languageService: LanguageService,
    private accountService: AccountService,
    private router: Router,
    private surveyConfig: SurveyConfigService) {

    const cachedVersion = localStorage.getItem('appVersion');
    if (cachedVersion !== this.version) {
      localStorage.setItem('appVersion', this.version);
      window.location.reload();
    }
    this.translate.addLangs(['en', 'de']);
    var language = this.accountService.getLanguage();
    this.translate.setDefaultLang(language);
    this.translate.use(language);

    this.translate.onLangChange.subscribe(() => {
      this.loadMenu();
    });

    this.languageService.changeLanguage(this.languageService.getLanguageEnum(language));
  }

  ngOnInit() {
    this.detectScreenSize();

    this.loadMenu();

    this.user = this.accountService.getUser();
    this.isUserLoggedIn = this.user != null;

    this.accountService.userSubject$.subscribe(val => {
      this.isUserLoggedIn = val != null;
      this.user = val;
    })
  }

  loadMenu() {
    this.items = [
      {
        label: this.translate.instant('Main'),
        icon: 'pi pi-home',
        command: () => {
          this.router.navigate(['/']);
        }
      },
      {
        label: this.translate.instant('Current Year Competition', { year: this.surveyConfig.currentYear }),
        icon: 'pi pi-home',
        command: () => {
          this.router.navigate(['/current-competition']);
        }
      },
      {
        label: this.translate.instant('Previous Year Competition', { year: this.surveyConfig.previousYear }),
        icon: 'pi pi-home',
        command: () => {
          this.router.navigate(['/previous-competition']);
        }
      },
      {
          label: this.translate.instant('Introduction'),
          icon: 'pi pi-book',
          command: () => {
            this.router.navigate(['/legal']);
          }
      },
      {
          label: this.translate.instant('Sign out'),
          icon: 'pi pi-sign-out',
          command: () => {
            this.singOut();
          }
      },
    ];
  }

  isBigScreen() {
    return window.innerWidth > 680;
  }
  @HostListener('window:resize', [])
  public onResize() {
    this.detectScreenSize();
  }

  private detectScreenSize() {
    this.screenWidth = window.innerWidth;
  }

  public changeLanguage(lang) {
    console.log('changeLanguage: ' + lang);
    this.translate.use(lang);
    this.loadMenu();
    this.languageService.changeLanguage(this.languageService.getLanguageEnum(lang));
    this.accountService.setLanguage(lang);
  }

  singOut() {
    this.accountService.logout();
  }
}
